import { sonarHttpPostStream } from '@sonar-software/sonar-http';

export type PostChatAgentPage = {
	route: string;
	entityType?: string;
	entityId?: number;
	parameters?: Record<string, string>;
};

export type PostChatAgentRequest = {
	userMessage: string;
	conversationId?: number;
	page?: PostChatAgentPage;
	replaceFromChunkId?: number;
};

export const postChatAgent = (request: PostChatAgentRequest, signal?: AbortSignal) =>
	sonarHttpPostStream({
		requestBody: request,
		signal,
		targetUri: '/api/v3/agent/turns'
	});
